export default __webpack_public_path__ + "static/media/hi.56c68467.svg";